import React from "react";
import {
  CiMonitor,
  CiSearch,
  CiHospital1,
  CiStethoscope,
  CiCamera,
  CiSettings,
  CiBrightnessDown,
} from "react-icons/ci";
import { IoShieldOutline, IoPersonAddOutline } from "react-icons/io5";
import {
  MdOutlineManageHistory,
  MdOutlinePeopleAlt,
  MdOutlineHealthAndSafety,
} from "react-icons/md";
import { GiEternalLove, GiOfficeChair } from "react-icons/gi";
import { RiCheckboxMultipleBlankLine } from "react-icons/ri";

const SkillDevelopmentProgramObj = [
  {
    icon: <CiMonitor size={40} />,
    program: "Digital Marketing",
  },
  {
    icon: <CiSearch size={40} />,
    program: "SEO",
  },
  {
    icon: <IoShieldOutline size={40} />,
    program: "Security Management",
  },
  {
    icon: <MdOutlineManageHistory size={40} />,
    program: "Facility Management",
  },
  {
    icon: <CiHospital1 size={40} />,
    program: "Hospitality Management",
  },
  {
    icon: <GiEternalLove size={40} />,
    program: "Patient Care",
  },
  {
    icon: <MdOutlinePeopleAlt size={40} />,
    program: "Geriatric Care",
  },
  {
    icon: <CiStethoscope size={40} />,
    program: "General Duty Assistance",
  },
  {
    icon: <CiCamera size={40} />,
    program: "CCTV Installation Technician",
  },
  {
    icon: <CiSettings size={40} />,
    program: "Access Control",
  },
  {
    icon: <CiBrightnessDown size={40} />,
    program: "Solar Panel Installation Technician",
  },
  {
    icon: <RiCheckboxMultipleBlankLine size={40} />,
    program: "Multi Skilled Technician",
  },
  {
    icon: <GiOfficeChair size={40} />,
    program: "Multi Purpose Office Executive",
  },
  {
    icon: <IoPersonAddOutline size={40} />,
    program: "Assistant Beauty Technician",
  },
  {
    icon: <MdOutlineHealthAndSafety size={40} />,
    program: "Wellness Therapist",
  },
];

const divStyle = {
  color: "#183b56",
};

const SkillDevelopment = () => {
  return (
    <div className="">
      <h5 className="title-styling header fw-medium pb-3" style={divStyle}>
        Skill Development
      </h5>
      <div className="d-flex w-100 flex-wrap">
        {SkillDevelopmentProgramObj.map((obj) => {
          return (
            <div
              key={obj.program}
              className=" card border border-1 gap-5 shadow-sm hover-shadow Employabilitybody"
              style={{ transition: "all 0.3s ease" }}
            >
              <div className="w-100 h-100">
                <div className="Employabilityskill">
                  <h2 className="">{obj?.icon}</h2>
                  <div className="flex-grow-1 Employabilitytext">
                    <h6 className="mb-0 w-fit">{obj?.program}</h6>
                  </div>
                </div>
              </div>
              <style
                dangerouslySetInnerHTML={{
                  __html: `
          .hover-shadow:hover {
            box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
            transform: translateY(-2px);
          }
        `,
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SkillDevelopment;
